import HWLocalStorage from '../HWLibrary/HWLocalStorage';
class S360Config {
    sourceOrigin = null; // SDK client origin.
    clientHostId = null; // SDK client host Id.
    config     = {};
    userData   = {};
    s360UserConfig = null;

    constructor() {
        if (!S360Config.instance) { S360Config.instance = this }
        this.config = this.getConfig();
        return S360Config.instance
    }

     sendUserData = (data) => {
        console.log("getting",data);
        this.userData = data;
        // call
        // xmppService.sendUserMetaData(data);
      
        console.log("yes");
      }

    // Configure client connection details.
    setSourceAndOriginFrom = (clientConfig) => {
        // console.log(clientConfig)
        this.sourceOrigin = clientConfig.sourceOrigin;
        this.clientHostId = clientConfig.clientHostId;
    }


    isClientHostConfigured = () => { return !(!this.sourceOrigin || !this.clientHostId) }

    getConfig = () => {
        if (!this.isClientHostConfigured()) { return {}; }
        let chatConfigKey = this.clientHostId + "-s360-config-key";
        return HWLocalStorage.load(chatConfigKey) || {};
    }

    setConfig = (config) => {
        if (!this.isClientHostConfigured()) { return; }
        let chatConfigKey = this.clientHostId + "-s360-config-key";
        console.log("update",chatConfigKey)
        HWLocalStorage.save(config, chatConfigKey);
        this.loadS360Config();
    }

    loadS360Config = () => {
        if (!this.isClientHostConfigured()) { return; }
        let chatConfigKey = this.clientHostId + "-s360-config-key";
        let configData = HWLocalStorage.load(chatConfigKey) || {};
        this.config = configData; // Config variable below.
    }

    isConfigured = () => {
        if (!this.isClientHostConfigured()) { return false; }
        let chatConfigKey = this.clientHostId + "-s360-config-key"
        return HWLocalStorage.load(chatConfigKey) != null;
    }

    loadClientConfigFromToken = () => {
        let configEncodedString = (window.location.pathname || "").substring(1, (window.location.pathname || "").length);
        if (!configEncodedString) { console.log("Invalid Configuration: "); return; }
        let decodedConfig = this.decodeConfigToken(configEncodedString);
        if (!decodedConfig) { return null; }
        console.log(configEncodedString,decodedConfig,window.location.pathname,"security")
        this.setSourceAndOriginFrom(decodedConfig);
        this.loadS360Config();
        this.loadS360UserConfig();
    }

    decodeConfigToken = function (encodedStringURI) {
        if (!encodedStringURI) { return null; }
        let decodedStringURI    = decodeURIComponent(encodedStringURI);
        let decodedBase64String = atob(decodedStringURI);
        let decodedSurveyConfiguration = JSON.parse(decodedBase64String);
        return decodedSurveyConfiguration;
    }

    // MARK: User From Configuration
    getUserConfig = () => {
        if (!this.isClientHostConfigured()) { return {}; }
        let chatConfigKey = this.clientHostId + "-s360-user-config-key";
        return HWLocalStorage.load(chatConfigKey) || {};
    }

    setUserConfig = (config) => {
        // let oldConfig = localStorage.getItem("s360-config-data");
        // console.log("OLD CONFIG",oldConfig)
        // localStorage.setItem("s360-config-data", JSON.stringify(config));
        // if (!this.isClientHostConfigured()) { return; }
      
        let chatConfigKey = this.clientHostId + "-s360-user-config-key";
        HWLocalStorage.save(config, chatConfigKey);
        this.loadS360UserConfig();
        this.config.user = config;
        
    }

    loadS360UserConfig = () => {
       
        if (!this.isClientHostConfigured()) { return; }
        let chatConfigKey = this.clientHostId + "-s360-user-config-key";
        let config = HWLocalStorage.load(chatConfigKey) || {};
        console.log("CONFIG HERE",config)
        if(sessionStorage.getItem(`s360-user-config-${this.config.configId}`)=== null)
       {
        
         sessionStorage.setItem(`s360-user-config-${this.config.configId}`,JSON.stringify(config))
        }
        this.s360UserConfig = config; // user variable from setUser.
         
        
    }

    isUserAttributesConfigured = () => {
        let chatConfigKey = this.clientHostId + "-s360-user-config-key";
        return HWLocalStorage.load(chatConfigKey) !== null;
    }
returnUser=()=>{
     
return  {data:
    this.s360UserConfig,
    success:this.s360UserConfig!== null
}

}
}

export var s360ConfigService = new S360Config();
// export var s360ConfigService = () => { return s360ConfigInstance; }